import { createContext, useContext } from 'react';

const ConfiguredFormContext = createContext();

export const { Provider: ConfiguredFormProvider } = ConfiguredFormContext;
export const useConfiguredFormContext = () => useContext(ConfiguredFormContext);
export default ConfiguredFormContext;
